import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const UserAuthContext = createContext();

export function UserAuthProvider({ children }) {
  const [user, setUser] = useState(null);

  // 🔹 1. Sayfa yüklendiğinde SSO token ile login
useEffect(() => {
  const checkSSO = async () => {
    // URL query parametrelerinden sso_token al
    const params = new URLSearchParams(window.location.search);
    const ssoToken = params.get("sso_token");
    console.log("SSO token:", ssoToken);
    if (!ssoToken) return;

    // Aynı token için refresh loop olmasın diye “bir kere” guard
    const refreshKey = `sso_refreshed_${ssoToken}`;
    const alreadyRefreshed = sessionStorage.getItem(refreshKey);

    try {
      const res = await axios.get(
        `https://kariyer.biyomed.net/api/sso/sso-login?sso_token=${encodeURIComponent(
          ssoToken
        )}`,
        { withCredentials: true }
      );

      if (res.data.user) {
        const { email, type } = res.data.user;
        setUser({ email, type });

        localStorage.setItem("email", email);
        localStorage.setItem("type", type);
        console.log("✅ SSO login başarılı:", email);

        // Token query param’ı temizle (URL’den)
        window.history.replaceState({}, document.title, window.location.pathname);

        // Navbar / auth state toparlansın diye sayfayı 1 kere hard refresh et
        if (!alreadyRefreshed) {
          sessionStorage.setItem(refreshKey, "1");
          window.location.replace(window.location.pathname); // tek seferlik refresh
        }
      }
    } catch (err) {
      console.log("SSO ile giriş başarısız:", err.message);
    }
  };

  checkSSO();
}, []);

  // 🔹 2. Normal login (local test veya doğrudan giriş)
  const login = async (email, password, loginType) => {
    let url = loginType === "user"
      ? 'https://kariyer.biyomed.net/api/user/login'
      : 'https://kariyer.biyomed.net/api/company/login';

    try {
      const response = await axios.post(url, { email, password }, { withCredentials: true });
      const { type, isFirstLogin } = response.data;

      localStorage.setItem('email', email);
      localStorage.setItem('type', type);
      localStorage.setItem('first', isFirstLogin);
      setUser({ email, type });

      // yönlendirme
      if (isFirstLogin === 1 ) {
        window.location.href = "/waiting-approval";
      } 
      else if (isFirstLogin === 2) {
        window.location.href = "/setPassword";
      }
      else {
        window.location.href = "/";
      }
    } catch (error) {
      console.error('Giriş hatası:', error);
      throw new Error('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    }
  };

  // 🔹 3. Logout işlemi
  const logout = async (loginType) => {
    let url = loginType === "user"
      ? 'https://kariyer.biyomed.net/api/user/logout'
      : 'https://kariyer.biyomed.net/api/company/logout';

    localStorage.clear();
    setUser(null);
    await axios.post(url, {}, { withCredentials: true });
    window.location.href = '/';
  };

  return (
    <UserAuthContext.Provider value={{ user, login, logout }}>
      {children}
    </UserAuthContext.Provider>
  );
}

export const useUserAuth = () => useContext(UserAuthContext);
